module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-2-en-US-9e451da465fa4e9437a33c05e748ce05.png";